import { DOCUMENT } from '@angular/common';
import { Component, OnInit, EventEmitter, Output, Inject, Input } from '@angular/core';
import { Router } from  '@angular/router';
import { LocalStorage, Modules, SubMenues } from 'src/app/appCommon/Enums/enum';
import { AuthService } from 'src/app/appServices/AuthService/auth.service';
import { PiteamService } from 'src/app/appServices/DefineService/piTeam-service';
import { HelperService } from 'src/app/appServices/HelperService/helper.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  userName: any;
  currentDate = "";
  currentTime: any;
  profileImageUrl: any;
  elem: any;
  screenBol: boolean = false;
  screenSize: boolean = false;

  @Input() showToggle!: boolean;

  @Output() sideNavToggle = new EventEmitter<any>();
  fullScreen: string = "Full Screen";
  ScreenIcon: string = 'pi pi-window-maximize';
  constructor(
    private authService: AuthService,
    private router: Router,
    public PiTeamService: PiteamService,
    private helperService: HelperService,
    @Inject(DOCUMENT) private document: any
  ) { }
  ngOnInit(): void {
    this.userName = this.helperService.decryption(localStorage.getItem(LocalStorage.UserFullName));
    this.profileImageUrl = this.helperService.decryption(localStorage.getItem(LocalStorage.UserImageUrl));
    this.profileImageUrl = this.profileImageUrl.toString();
    //set default image
    if (this.profileImageUrl == "not available") {
      this.profileImageUrl = '/assets/images/users/user.jpg';
    }
    this.currentDateTime();
    this.elem = document.documentElement;
  }

  toggleSidenav() {
    this.sideNavToggle.emit('clicked')
    if (document.getElementById('header')!.classList.contains('fixed-header')) {
      document.getElementById('header')?.classList.toggle('w-full');
    }
  }

  logOut() {
    this.authService.logout();
  }

  changeUserRoute() {
    this.PiTeamService._profileEdit = true; 
    if (this.router.url == `/${Modules.Layout}/${Modules.Define}/${SubMenues.CreateUsers}`) {
      localStorage.setItem(LocalStorage.UserEditProfile, "true");
      this.PiTeamService._createUsersComponent.editLoggedUser();
    }
    else {
      this.changeRouter(`/${Modules.Layout}/${Modules.Define}/${SubMenues.CreateUsers}`)
    }
  }

  changeRouter(value: any) {
    this.router.navigate([value])
  }

  currentDateTime() {
    setInterval(() => {
      var data;
      var today = new Date();
      this.currentTime = today;//today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      today.toLocaleString('it-IT', { month: 'long' });
      data = today.toString();
      data = data.split(' ');
      this.currentDate = data[1].concat(' ').concat(data[2]).concat(',').concat(data[3]);
    }, 1000)
  }

  openFullscreen() {
    if (!this.document.fullscreen) {
      this.fullScreen = "Exit Full Screen";
      this.ScreenIcon = 'pi pi-window-minimize';
      if (this.elem.requestFullscreen) {
        this.elem.requestFullscreen();
      } else if (this.elem.mozRequestFullScreen) {
        /* Firefox */
        this.elem.mozRequestFullScreen();
      } else if (this.elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.elem.webkitRequestFullscreen();
      } else if (this.elem.msRequestFullscreen) {
        /* IE/Edge */
        this.elem.msRequestFullscreen();
      }
    }
  }
  /* Close fullscreen */
  closeFullscreen() {
    if (this.document.fullscreen) {
      this.fullScreen = "Full Screen";
      this.ScreenIcon = 'pi pi-window-maximize pi-2x';
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }
}